export default class SingletonError extends Error {

    constructor(singletonName: string, methodName = 'getInstance') {
        super(`Tried to instantiate ${singletonName} without static method ${methodName}`);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/common/errors/SingletonError.ts